import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h6", null, "Номенклатура заказа", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CatalogueGrid = _resolveComponent("CatalogueGrid")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createVNode(_component_CatalogueGrid, {
      summaryConfig: _ctx.summaryConfig,
      controller: 'PlanOrderNomenclatureResult',
      columns: _ctx.columns,
      filterRowVisible: true,
      groupPanelVisible: false,
      headerFilterVisible: true,
      filterPanelVisible: false,
      showPageSizeSelector: !_ctx.selectMode,
      pageSize: 10,
      pageSizes: _ctx.pageSizes,
      editingConfig: _ctx.editingConfig,
      selectionConfig: _ctx.selectionConfig,
      designConfig: _ctx.designConfig,
      getSelectedData: _ctx.getSelectedData,
      changeSelectedData: _ctx.changeSelectedData,
      parentModel: _ctx.parentModel,
      popupCreateEditComponent: _ctx.planOrderNomenclatureCreateEditDialog,
      selectMode: _ctx.selectMode,
      onInsertedCallback: _ctx.refreshParent,
      onUpdatedCallback: _ctx.refreshParent,
      onRowRemovedCallback: _ctx.refreshParent,
      toolbarItems: _ctx.toolbarItems,
      onRowPrepared: _ctx.onRowPrepared,
      onSelectionChanged: _ctx.onSelectionChanged,
      ref: "grid"
    }, null, 8, ["summaryConfig", "columns", "showPageSizeSelector", "pageSizes", "editingConfig", "selectionConfig", "designConfig", "getSelectedData", "changeSelectedData", "parentModel", "popupCreateEditComponent", "selectMode", "onInsertedCallback", "onUpdatedCallback", "onRowRemovedCallback", "toolbarItems", "onRowPrepared", "onSelectionChanged"])
  ], 64))
}